"use client";

import { useTrackUserEvent } from "@/utils/analytics";
import Button from "../SecondaryButton";
import EthIcon from "@/assets/eth.svg";
import { useAutoConnect, useConnectModal } from "thirdweb/react";
import { chain, thirdWebClient, wallets } from "@/app/libs/thirdweb";

const ConnectWalletButton = () => {
  const { connect, isConnecting } = useConnectModal();

  const trackUserEvent = useTrackUserEvent();

  useAutoConnect({
    client: thirdWebClient,
    wallets,
  });

  const onClick = async () => {
    if (isConnecting) return;

    const wallet = await connect({
      client: thirdWebClient,
      wallets,
      size: "compact",
    });
    await wallet?.switchChain(chain);
  };

  return (
    <Button
      onClick={() => {
        trackUserEvent("Connect Wallet Click");
        onClick();
      }}
      variant="light"
    >
      <EthIcon />
      CONNECT WALLET
    </Button>
  );
};

export default ConnectWalletButton;
